<template>
  <div class="wrapper" style="height: 100%;">
    <!--<div v-if="!isInitid" class="no-initid red">请先绑定公众号</div>-->
    <div>
      <div class="header-wrapper">
        <div class="header">管理员设置</div>
        <Button class="addManager" type="primary" @click="addBtn">添加管理员</Button>
      </div>
      <div class="content" style="padding-left: 10px">
        <sqfw-card :spinShows="spinShows" :adminList="adminList" @delAdmin="delAdmin"></sqfw-card>
      </div>
    </div>
    <Modal
      v-model="showModal"
      title="添加管理员"
      :mask-closable="false"
      width="660"
      @on-ok="addAdmin"
      @on-cancel="modalCancel"
      class-name="vertical-center-modal"
    >
      <!--@on-change="handleClick"-->
      <div class="tr box">
        <div class="tr_title">管理权限</div>
        <Select v-model="modelSelect" style="width:560px" placeholder="请选择管理员权限" size="large">
          <Option
            v-for="(item,index) in zoneList"
            :value="item.zoneId"
            :key="index"
          >{{ item.zoneName }}</Option>
        </Select>
      </div>
      <div class="tr box">
        <div class="tr_title" style="padding-top:15px">人员</div>
        <Input
          v-model="modelInput"
          size="large"
          placeholder="请输入微信昵称/真实姓名"
          style="width: 560px;padding-top:15px;"
          enter-button="搜索"
          search
          @on-search="inputSearch"
        />
      </div>
      <div class="searchcard-wrapper" id="adminSearch">
        <div v-if="isData" class="nodata red">搜索不到该用户。请输入正确的微信昵称或真实姓名，并保证该用户已使用过本社区的{{promptMsg}}</div>
        <div
          v-else
          class="search-card"
          v-bind:class="{select:item.isSelect}"
          v-for="(item,index) in userlist"
          :key="index"
          @click="selectAdmin(item,index,$event)"
        >
          <img
            v-if="item.isSelect"
            class="xuanzhong-icon color"
            src="../../assets/images/select.png"
          />
          <div class="img">
            <img v-if="item.headPicUrl" :src="item.headPicUrl" />
            <img v-else src="../../assets/images/default.png" />
          </div>
          <div class="search-name">{{item.userName?item.userName:'暂未绑定微信'}}</div>
          <div class="search-username">{{item.realName?item.realName:'暂无姓名'}}</div>
        </div>
      </div>
    </Modal>
    <delete-people
      v-if="isShowSelect"
      :modal="isShowSelect"
      :message = "message"
      :api="urlobj.allAdmin()"
      :params="rule"
      :deleteUnionid = "deleteData.unionId"
      @onDelete="turnToOther"
      @onCancel="onCancel"
      title="删除社工">
    </delete-people>
    <infinite-loading :identifier="newRule" @infinite="loadMore">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
import sqfwCard from "./components/sqfwCard";
import deletePeople from "../userManager/components/deletePeople";
var that;
export default {
  name: "adminManage",
  components: {
    sqfwCard,
    deletePeople
  },
  data() {
    return {
      isShowSelect:'',//是否展示转派弹窗
      modelSelect: "", //选择的行政区域的id
      modelInput: "", //弹窗中的输入框输入的微信昵称 string
      adminList: [], //主页面显示的管理员列表
      showModal: false, //控制是否显示搜索弹窗
      userlist: [], //搜索弹窗中搜索结果
      arrp: [], //搜索弹窗中搜索结果的选中项   id
      page: 1,
      rows: 12,
      spinShows: false,
      rightSelect: [], //右侧标签选择情况  被选择的id
      rightName: "", //右侧输入搜索   string
      isData: false, //搜索弹窗搜索是否有结果
      newRule: 0,
      zoneList: [],
      isInitid: false,
      copyAdminList: [],
      isload: false, //是否正在加载
      noData: false,
      userInfo: {},
      filterList:[],//右侧筛选框
      rule:{
        isManager:1,
        zoneIdList:[],
        userName:''
      }
    };
  },
  methods: {
    turnToOther(turn_unionId){
      let data = this.deleteData
      data.turn2UnionId = turn_unionId
      this.delAdmin(data)
    },
    onCancel() {
      this.isShowDelete = false;
      this.isShowSelect = false;
    },
    addBtn() {
      this.showModal = true;
      var url = this.urlobj.getZone();
      this.$get(url, {}).then(res => {
        this.zoneList = res.rows.map(item => {
          item.isSelect = false;
          return item;
        });
      });
    },
    loadMore(loadingContext) {
      this.getAllAdmin(loadingContext);

    },
    //输入框搜索
    inputSearch() {
      if (!this.modelSelect) {
        this.$Message.warning("请选择管理员权限");
        return;
      }
      this.page = 1;
      this.arrp = [];
      this.isData = false;
      this.noData = false;
      this.userlist = [];
      this._searchManger();
    },
    // 搜索第一页管理员 与分页分开
    _searchManger() {
      var userName = this.modelInput;
      var url = this.urlobj.allAdmin();
      var zoneIdList = [this.modelSelect];
      this
        .$post(url, {
          pageNum: 1,
          pageSize: this.rows,
          isManager: 0,
          zoneIdList,
          userName
        })
        .then(res => {
          if (res.rows.length == 0) {
            this.isData = true;
          }
          var list = [];
          res.rows.forEach(item => {
            item.isSelect = false;
            list.push(item);
          });
          this.userlist = list;
        });
    },
    // 滚动分页
    searchManger() {
      if (this.noData) return;
      this.isload = true;
      var userName = this.modelInput;
      var url = this.urlobj.allAdmin();
      var zoneIdList = [this.modelSelect];
      this
        .$post(url, {
          pageNum: this.page,
          pageSize: this.rows,
          isManager: 0,
          zoneIdList,
          userName
        })
        .then(res => {
          this.isload = false;
          if (res.rows.length < this.rows) {
            this.noData = true; //已加载全部
          }
          var list = this.userlist;
          res.rows.map(item => {
            item.isSelect = false;
            list.push(item);
          });
          console.log(list, "-----------------");
          this.userlist = list;
        });
    },
    //搜索完之后，选择要添加的管理员
    selectAdmin(res, index, event) {
      var unionId = res.unionId;
      this.userlist.forEach(item => {
        if (item.unionId == unionId) {
          item.isSelect = true;
          console.log(item)
          this.userInfo = item;
        } else {
          item.isSelect = false;
        }
      });
      //防止重复添加数据
      if (this.arrp.length > 0) {
        this.arrp.splice(0, 1, unionId);
      } else {
        this.arrp.push(unionId);
      }
    },
    //点击弹窗确定按钮，添加管理员
    addAdmin() {
      if (!this.modelSelect) {
        this.$Message.warning("请选择管理员权限");
        return;
      }
      if (!this.arrp) {
        this.$Message.warning("请选择管理员");
        return;
      }
      var url = this.urlobj.saveAdmin();
      this
        .$post(url, {
          unionId: this.arrp[0],
          userName: this.userInfo.userName,
          headPicUrl: this.userInfo.headPicUrl,
          zoneId: this.modelSelect
        })
        .then(res => {
          this.getfilter();
          this.page = 1;
          this.newRule++;
          this.arrp = [];
          this.userlist = [];
          this.modelSelect = "";
          this.modelInput = "";
          this.isData = false;
          this.noData = false;
          this.adminList = [];
        });
    },
    //点击弹窗取消按钮，清空
    modalCancel() {
      this.arrp = [];
      this.userlist = [];
      this.modelSelect = "";
      this.modelInput = "";
      this.isData = false;
    },
    //获取所有管理员
    getAllAdmin(loadingContext) {
      var url = this.urlobj.allAdmin();
      this
        .$post(url, {
          pageNum: this.page,
          pageSize: this.rows,
          isManager: 1,
          zoneIdList: this.rightSelect,
          userName: this.rightName
        })
        .then(res => {
          this.$store.commit("updateSpinShow", false);
          if (res.rows.length) {
            this.page++;
            loadingContext.loaded(); // 结束加载状态
            res.rows.map(item => {
              item.showCha = false;
              this.adminList.push(item);
            });
            if (!this.rightSelect.length && !this.rightName) {
              this.copyAdminList = this.adminList;
            }
          } else {
            /* 如果没有数据 完成加载 */
            loadingContext.complete();
          }
        });
    },
    //删除管理员
    delAdmin(data) {
      if (this.copyAdminList.length == 1) {
        this.$Message.warning("管理员不能再少了");
        return;
      }
      var url = this.urlobj.delAdmin();
      let req_data = {
        unionId: data.unionId,
        zoneIdList: data.delList,
      }
      if(data.turn2UnionId)req_data.turn2UnionId = data.turn2UnionId
      console.log(req_data)

      this
        .$post(url, req_data)
        .then(res => {
          this.isShowSelect = false
          this.rightName = "";
          this.rightSelect = [];
          this.page = 1;
          this.newRule++;
          this.$Message.success("删除成功");
          this.getfilter();
          this.adminList = [];

        }).catch(e=>{
          console.log(e)
          this.deleteData = data
          if(e.data.code == 999900){
              this.isShowSelect = true
              this.message = e.data.message
            }
          //this.$Message.error("删除失败");
        })
    },
    handleScroll() {
      var a = document.getElementById("adminSearch");

      var scrollTop = a.scrollTop; //变量scrollTop是滚动条滚动时，距离顶部的距离

      var windowHeight = a.clientHeight; //变量windowHeight是可视区的高度
      var scrollHeight = a.scrollHeight; //变量scrollHeight是滚动条的总高度
      if (scrollTop + windowHeight + 10 > scrollHeight) {
        //写后台加载数据的函数
        console.log("触底");
        if (!this.isload && !this.noData) {
          ++this.page;
          this.searchManger();
        }
      }
    },
    // 获取右侧筛选列表内容
    getfilter () {
        this.filterList = []
        var filterData= []
        var _url = this.urlobj.labelAdmin();
        this.$get(_url,{}).then(res => {
          filterData.push({
            type: "community",
            name: "分类",
            children: res.rows.map(item => {
              return {
                name: item.zoneName,
                id: item.id,
                userCount: item.userCount
              };
            })
          });
          for (const obj in filterData) {
            this.filterList.push(new FilterItem(filterData[obj]));
          }
          this.initFilterList(this.filterList);
        })
    },
    /* 初始化筛选列表 */
    initFilterList(list) {

      /* search 数据 */
      let search = {
        name: "search",
        data: {},
        event: function(e) {
          that[e.fn](e);
        }
      };
      list.unshift(search);
      this.$store.commit("updateFilterList", list);
    },
    /* ---------------------所有 筛选 业务处理 代码 如下--------------------*/
    /* 重置筛选列表 */
    _reset() {
      console.log('重置')
      this.adminList = [];
      this.page = 1;
      this.newRule++;
      this.rightSelect = [];
      this.rightName = "";
    },
    /* ==================== 搜索  BEGIN==================== */
    search({ params }) {
      this.adminList = [];
      this.page = 1;
      this.newRule++;
      this.rightName = params.searchValue;
    },
    /* ==================== 搜索  END==================== */
    /* ==================== 行政区域  BEGIN==================== */
    areaChange({ params }) {
      this._groupChange(params);
    },
    /* 勾选筛选 初始化不同的属性*/
    _groupChange(e) {
      let target = this.filterList[e.filterListIndex];
      /* 修改筛选条件 source 传type 其他的传id*/
      if (target.type == "community") {
        this.rightSelect = e.selectedIndex.map(item => {
          return target.data.dataList[item].id;
        });
      }
      this.adminList = [];
      this.page = 1;
      this.newRule++;
      console.log(this.rightSelect)
    },
  },
  computed: {
    promptMsg: function () {
      return this.$store.state.apptype == 'ctt'?'丛台通或丛台先锋小程序':'民生通或先锋e家或社区云助手小程序'
    }
  },
  created() {
    console.log(this.$store.state.apptype)
    if (this.$store.state.initid) {
      this.isInitid = true;
      this.$store.commit("updateSpinShow", true);
    }
    this.reset = this._.debounce(this._reset, 500); // filter 重置后会触发
    this.getfilter()
  },
  mounted() {
    that = this;
    this.$nextTick(() => {
      document
        .getElementById("adminSearch")
        .addEventListener("scroll", this.handleScroll);
    });
  },
  watch:{
    modelSelect(){
      this.rule = {
        isManager:1,
        zoneIdList:this.modelSelect?[this.modelSelect]:[],
        userName:''
      }
    }
  }
};
/* ---------------------------筛选组件构造对象 --------------------------*/
/*
  type : 用来确定 使用哪个组件
  name ：组件显示的头部文字
  children: 子列表数据
*/
function FilterItem({ type, name, children }) {
  /* 初始化 组件类型 this.name 确定组件类型*/
  switch (type) {
    case "community":
      this.name = "division";
      break;
  }
  /* 对象类型 */
  this.type = type;
  /* 初始化对象 数据 */
  this.data = {
    title: name, // 解构过来的name
    edit: false,
    dataList: children.map((item, index) => {
      return {
        id: item.id,
        label: item.name,
        number: item.userCount,
        iconPath: '',
        type: item.type || "",
      };
    })
  };
  /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
  this.event = function(e) {
    that[e.fn](e);
  };
}
</script>

<style scoped lang="less">
.no-initid {
  position: fixed;
  top: 50%;
  left: 50%;
  font-size: 20px;
}
.wrapper {
  color: #666666;
}
.no-initid {
  position: fixed;
  top: 50%;
  left: 50%;
  font-size: 20px;
}
.header-wrapper {
  display: flex;
  /*height: 30px;*/
  line-height: 30px;
  padding-top: 30px;
  justify-content: center;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  /*background: #fd7c42;*/
  position: absolute;
  right: 20px;
}
/*.vertical-center-modal{*/
/*display: flex;*/
/*align-items: center;*/
/*justify-content: center;*/
/*.ivu-modal{*/
/*top: 0;*/
/*}*/
/*}*/

.searchcard-wrapper {
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  height: 180px;
  overflow: auto;
  /*overflow: scroll;*/
}
.search-card {
  width: 120px;
  height: 150px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  position: relative;
}
.img {
  padding: 30px 0 20px 35px;
}
.img img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.search-name {
  text-align: center;
  color: #4b4b4b;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.search-username {
  text-align: center;
  color: #999;
}
.nodata {
  margin: 0 auto;
  padding-top: 40px;
}
/*.searchcard-wrapper {*/
/*display: flex;*/
/*flex-wrap: wrap;*/
/*}*/
.searchcard-wrapper::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ccc;
}
.select {
  border: 2px solid #ff7b44;
}
.xuanzhong-icon {
  position: absolute;
  top: -12px;
  right: -14px;
  height: 25px;
  width: 25px;
}
/deep/ .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
.tr{
    line-height: 36px;
    .tr_title{
        margin-right: 20px;
        width: 60px;
    }
}
</style>
